export const InspectButtonStatus = {
  NONE: 0,
  INCOMPLETE: 1,
  COMPLETED: 2
};
